var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-page-title"},[_c('h1',{staticClass:"c-page-title__heading"},[_vm._t("default")],2),(_vm.subTitle)?_c('p',{staticClass:"c-page-title__subtitle"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }